import styled, { keyframes } from "styled-components";
import { useNav } from "context/navContext";

function Loader({ style }) {
  const { accessibilityMode } = useNav();

  return (
    <Wrapper style={style} accessibilityMode={accessibilityMode}>
      <LoaderWrapper></LoaderWrapper>
    </Wrapper>
  );
}

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const prixClipFix = keyframes`
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }
  75%, 100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: ${({ accessibilityMode }) => accessibilityMode ? "82vh" : "50%"};
  left: 50%;
  transform: translate(-50%, -50%);
  width: 128px;
  height: 128px;
`;

const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ width }) => width || "128px"};
  height: ${({ height }) => height || "128px"};
  border-radius: 50%;
  position: relative;
  animation: ${rotate} 1s linear infinite;

  &::before,
  &::after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 10px solid var(--primary);
    animation: ${prixClipFix} 2s linear infinite;
  }

  &::after {
    transform: rotate3d(90, 90, 0, 180deg);
    border-color: transparent;
  }
`;

export default Loader;
